import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SystemAnnouncement } from './system-announcements.types';

@Injectable()
export class SystemAnnouncementService {
  constructor(private http: HttpClient) {}

  getAnnouncements(): Observable<SystemAnnouncement[]> {
    return this.http.get<SystemAnnouncement[]>(`api/announcements`);
  }

  saveAnnouncements(dataDto: SystemAnnouncement, id?: string): Observable<SystemAnnouncement[]> {
    if (id) {
      return this.http.patch<SystemAnnouncement[]>(`api/announcements/${id}`, dataDto);
    } else {
      return this.http.post<SystemAnnouncement[]>(`api/announcements`, dataDto);
    }
  }

  deleteAnnouncement(announcementId: string) {
    return this.http.delete(`api/announcements/${announcementId}`);
  }

  fetchLatestAnnouncement = () => {
    return this.http.get<SystemAnnouncement>('api/announcements/by-user');
  };

  dismissAnnouncement = (announcementId: string) => {
    return this.http.patch('api/announcements/by-user/dismiss', { announcementId });
  };
}
